import { Query } from '@varo/graphql-schema-types';
import getSelfFundedOfferComponents from 'services/graphql/queries/rewards/GetSelfFundedOfferComponents';
import { useQuery } from 'urql';

const useRefreshSelfFundedOfferTile = () => {
  const [response, refetch] = useQuery<Query>({
    query: getSelfFundedOfferComponents,
    pause: true,
  });

  const { data, error, fetching } = response;

  return {
    data,
    error,
    fetching,
    refreshSelfFundedOfferTile: refetch,
  };
};

export default useRefreshSelfFundedOfferTile;
